/**
 * @Author: Zero
 * @Date: 2026-07-27 08:37:23
 * @Explain: 推送通知模型
 */

import type { Effect } from 'umi';
// api
import { pushNotificationApi } from '@/api';
// type
import { ConfigType } from '../api/pushNotification/data.d';
import { ReducersEnum } from './connect.d';
// utils
import { getActionType } from '@/utils/common/redux';
import { controlApprovalBadge } from '../components/leftMenu/menuCollapse';
import { PENDING_APPROVAL_STATUS } from '../pages/pushExperiment/utils/enum/list';

type PendingApprovalDataType = {
  /** 实验待审核数量 */
  experimentApprovalNumber: number;
  /** 默认推送待审核数量 */
  defaultApprovalNumber: number;
  /** 全部待审批总条数 */
  allApprovalNumber: number;
};

export const defaultPendingApprovalData: PendingApprovalDataType = {
  /** 实验待审核数量 */
  experimentApprovalNumber: 0,
  /** 默认推送待审核数量 */
  defaultApprovalNumber: 0,
  /** 全部待审批总条数 */
  allApprovalNumber: 0,
};

/** 参数声明 */
export type PushNotificationState = {
  // 待审核数量
  pendingApprovalData: PendingApprovalDataType;
};

export type ModelType = {
  namespace: string;
  state: PushNotificationState;
  reducers: {
    /** 待审核数量 */
    setPendingApprovalData: (
      state: PushNotificationState,
      action: { payload: PendingApprovalDataType },
    ) => any;
  };
  effects: {
    getPendingApprovalData: Effect;
  };
};

const PushNotification: ModelType = {
  namespace: 'PushNotificationModel',
  state: {
    pendingApprovalData: { ...defaultPendingApprovalData },
  },
  reducers: {
    setPendingApprovalData(state, action) {
      return {
        ...state,
        pendingApprovalData: {
          ...state.pendingApprovalData,
          ...action.payload,
        },
      };
    },
  },
  effects: {
    *getPendingApprovalData({}, { call, put }): any {
      // 获取默认推送待审核数量
      const result = yield call(pushNotificationApi.configCount, {
        status: PENDING_APPROVAL_STATUS,
        configType: ConfigType.ALL,
      });

      let allApprovalNumber = 0;
      if (result.code === 0) {
        allApprovalNumber = result?.data?.count || 0;
        yield put({
          type: getActionType(ReducersEnum.SET_PENDING_APPROVAL_DATA),
          payload: { allApprovalNumber },
        });

        controlApprovalBadge({ allApprovalNumber });
      }
    },
  },
};

export default PushNotification;
